/**
 * "Guides" documentation section (ADR-0074).
 *
 * Task-oriented how-tos that compose the reference docs into end-to-end flows —
 * launching the chat widget, connecting an AI client over MCP, grounding answers
 * in your content, letting the assistant act for a signed-in user, and going to
 * production. Each guide links to the canonical pages rather than restating them.
 */
import { GUIDES_ACT_AS_USER_PAGE } from './pages/guides-act-as-user.page';
import { GUIDES_ANALYTICS_GROUNDING_PAGE } from './pages/guides-analytics-grounding.page';
import { GUIDES_CATALOG_FRESHNESS_PAGE } from './pages/guides-catalog-freshness.page';
import { GUIDES_CONNECT_MCP_PAGE } from './pages/guides-connect-mcp.page';
import { GUIDES_DATA_EXPORT_ERASURE_PAGE } from './pages/guides-data-export-erasure.page';
import { GUIDES_GO_TO_PRODUCTION_PAGE } from './pages/guides-go-to-production.page';
import { GUIDES_GROUND_KNOWLEDGE_PAGE } from './pages/guides-ground-knowledge.page';
import { GUIDES_LAUNCH_ASSISTANT_PAGE } from './pages/guides-launch-assistant.page';
import { GUIDES_OVERVIEW_PAGE } from './pages/guides-overview.page';
import { GUIDES_ROI_METHODOLOGY_PAGE } from './pages/guides-roi-methodology.page';
import { GUIDES_TROUBLESHOOTING_PAGE } from './pages/guides-troubleshooting.page';

import type { DocSection } from './types';

export const GUIDES_SECTION: DocSection = {
  id: 'guides',
  titleKey: 'docs.section.guides.title',
  pages: [
    GUIDES_OVERVIEW_PAGE,
    GUIDES_LAUNCH_ASSISTANT_PAGE,
    GUIDES_CONNECT_MCP_PAGE,
    GUIDES_GROUND_KNOWLEDGE_PAGE,
    GUIDES_ANALYTICS_GROUNDING_PAGE,
    GUIDES_ACT_AS_USER_PAGE,
    GUIDES_CATALOG_FRESHNESS_PAGE,
    GUIDES_DATA_EXPORT_ERASURE_PAGE,
    GUIDES_ROI_METHODOLOGY_PAGE,
    GUIDES_GO_TO_PRODUCTION_PAGE,
    GUIDES_TROUBLESHOOTING_PAGE,
  ],
};
